import React from 'react';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, standardColours, fontSize } from '../../styles';
import { Link } from './Link';
import { Svg } from './Svg';

const commonIconButtonStyles = () => {
  return css`
    padding: 5px;
    color: ${standardColours.black};
    ${fontSize(8)};

    ${minBreakpointQuery.small`
      ${fontSize(10)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(12)};
    `}
  `;
};

const StyledIconButton = styled(Link)`
  ${commonIconButtonStyles()};
`;

const StyledIconButtonExternal = styled.a`
  ${commonIconButtonStyles()};
`;

const StyledIcon = styled(Svg)`
  display: block;
  margin: 0 auto;
  height: 28px;
  width: 28px;
`;

export const IconButton = ({ icon, children, ...props }) => {
  const IconButtonComponent = props.href
    ? StyledIconButtonExternal
    : StyledIconButton;

  return (
    <IconButtonComponent {...props}>
      <StyledIcon image={icon} />
      {children}
    </IconButtonComponent>
  );
};
